<script lang="ts">
  import {
    themes,
    themeStore,
  } from "$routes/(microsites)/gpu-glossary/_lib/gpu-glossary";
  import type { ThemeName } from "$routes/(microsites)/gpu-glossary/_lib/gpu-glossary";

  function setTheme(theme: ThemeName) {
    localStorage.setItem("themeName", theme);
    switch (theme) {
      case "lightGreen":
        themeStore.set(themes.lightGreen);
        break;
      case "terminal":
        themeStore.set(themes.terminal);
        break;
      case "light":
        themeStore.set(themes.light);
        break;
    }
  }
</script>

<button
  style:color={$themeStore === themes.terminal
    ? $themeStore.primary[100]
    : $themeStore.primary[60]}
  on:click={() => setTheme("terminal")}>Terminal</button
>
<button
  class="shrink-0"
  style:color={$themeStore === themes.lightGreen
    ? $themeStore.primary[100]
    : $themeStore.primary[60]}
  on:click={() => setTheme("lightGreen")}>Light green</button
>
<button
  style:color={$themeStore === themes.light
    ? $themeStore.primary[100]
    : $themeStore.primary[60]}
  on:click={() => setTheme("light")}>Light</button
>
